import { render, staticRenderFns } from "./ProductSetSlider.vue?vue&type=template&id=4d0baafc&scoped=true&"
import script from "./ProductSetSlider.vue?vue&type=script&lang=js&"
export * from "./ProductSetSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductSetSlider.vue?vue&type=style&index=0&id=4d0baafc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0baafc",
  null
  
)

export default component.exports